import React, { useEffect, useState } from "react";
import { TabPanel } from "@material-ui/lab";
import PerfectScrollbar from "react-perfect-scrollbar";
import { TabView } from "primereact/tabview";
import { ButtonGroup, Button } from "react-bootstrap";
import { formatDate } from "../../../../utils/utils";
import root from "react-shadow";
import parse from "html-react-parser";
import { Editor } from "primereact/editor";
import MaterialTable from "material-table";
import { Paper } from "@material-ui/core";
import MessageForm from "../../users/messages/messageForm";
import DialogLayout from "../../../../partials/content/DialogLayout";
import ChangeService from "./changeService";
import AssignItem from "./assignItem";
import QuotationForm from "../../sales/quotation/quotationForm/quotationForm";
import Swal from "sweetalert2";
import {
  claimTicket,
  getTicketDetail,
  getTicketMessages,
  replyTicketEmail,
} from "../../../../services/crm/ticketService";
function TicketDetail({ ticketID, onReloadTickets }) {
  const [openChangeService, setOpenChangeService] = useState(false);
  const [openAssignItem, setOpenAssignItem] = useState(false);
  const [openQuotationForm, setOpenQuotationForm] = useState(false);
  const [messages, setMessages] = useState([]);
  const [ticket, setTicket] = useState({
    ID: 0,
    emailInquiry: {
      body: "",
    },
    customer: {
      ID: 0,
    },
    lead: {
      ID: 0,
    },
    item: {
      ID: 0,
    },
    quotation: {
      ID: 0,
    },
    ticketReplyEmail: [],
    user: {
      ID: 0,
      firstName: "",
      lastName: "",
    },
  });
  const [replyMessage, setReplyMessage] = useState("");

  useEffect(() => {
    getTicketDetailData(ticketID);
  }, [ticketID]);
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <div className="tabview">
            <div className="card">
              <TabView className="tabview" scrollable>
                <TabPanel header="Ticket" rightIcon="fas fa-ticket-alt">
                  {ticket.ID > 0 ? (
                    <React.Fragment>
                      <div className="row">
                        <div className="col-sm-12 col-md-4 col-lg-4">
                          <ButtonGroup size="sm">
                            <Button variant="primary" onClick={() => {}}>
                              {ticket.customer.ID > 0
                                ? "Customer"
                                : ticket.lead.ID > 0
                                ? "Lead"
                                : "Not Registered"}
                            </Button>
                            {ticket.customer.ID > 0 ? (
                              <Button
                                variant="secondary"
                                onClick={() => {
                                  setOpenChangeService(true);
                                }}
                              >
                                Change Service
                              </Button>
                            ) : null}
                            {ticket.statusID === 1 && ticket.user.ID === 0 ? (
                              <Button
                                variant="secondary"
                                onClick={() => {
                                  claimTicketConfirmation();
                                }}
                              >
                                Claim Ticket
                              </Button>
                            ) : (
                              <React.Fragment>
                                {ticket.item.ID === 0 ? (
                                  <Button
                                    variant="secondary"
                                    onClick={() => {
                                      setOpenAssignItem(true);
                                    }}
                                  >
                                    Assign Item
                                  </Button>
                                ) : null}
                                {ticket.quotation.ID === 0 ? (
                                  <Button
                                    variant="secondary"
                                    onClick={() => {
                                      setOpenQuotationForm(true);
                                    }}
                                  >
                                    New Quotation
                                  </Button>
                                ) : null}
                              </React.Fragment>
                            )}
                          </ButtonGroup>
                          <br />
                          <br />
                          <table>
                            <tr>
                              {ticket.customer.ID > 0 ? (
                                <React.Fragment>
                                  <th>Customer</th>
                                  <th>:</th>
                                  <td>{ticket.customer.customerName}</td>
                                </React.Fragment>
                              ) : ticket.lead.ID > 0 ? (
                                <React.Fragment>
                                  <th>Lead</th>
                                  <th>:</th>
                                  <td>{ticket.lead.leadName}</td>
                                </React.Fragment>
                              ) : null}
                            </tr>
                            <tr>
                              <th>Subject</th>
                              <th>:</th>
                              <td>{ticket.subject}</td>
                            </tr>
                            <tr>
                              <th>Email</th>
                              <th>:</th>
                              <td>{ticket.emailInquiry.emailFrom}</td>
                            </tr>
                            <tr>
                              <th>Service</th>
                              <th>:</th>
                              <td>{ticket.userGroup.groupName}</td>
                            </tr>
                            <tr>
                              <th>Assigned To</th>
                              <th>:</th>
                              <td>
                                {" "}
                                {ticket.user.firstName +
                                  " " +
                                  ticket.user.lastName}
                              </td>
                            </tr>

                            {ticket.itemID > 0 ? (
                              <tr>
                                <th>Item Name</th>
                                <th>:</th>
                                <td>{ticket.item.itemName}</td>
                              </tr>
                            ) : null}
                            {ticket.quotationID > 0 ? (
                              <tr>
                                <th>Quotation ID</th>
                                <th>:</th>
                                <td>{ticket.quotation.ID}</td>
                              </tr>
                            ) : null}
                          </table>
                          <br />
                          <h3>Reply Inquiry</h3>
                          <Editor
                            style={{ height: "250px" }}
                            onTextChange={(e) => {
                              setReplyMessage(e.htmlValue);
                            }}
                            value={replyMessage}
                            placeholder="Type your reply messages here..."
                          />
                          <br />
                          {replyMessage !== "" ? (
                            <button
                              type="button"
                              className="btn btn-primary"
                              onClick={handleReplyTicketEmail}
                            >
                              Send
                            </button>
                          ) : null}
                        </div>
                        <div className="col-sm-12 col-md-8 col-lg-8">
                          <PerfectScrollbar>
                            <div className="chat-discussion">
                              {ticket.ticketReplyEmail.map((reply, index) => (
                                <div className="chat-message right">
                                  <img
                                    className="message-avatar"
                                    src={
                                      process.env.PUBLIC_URL +
                                      `/invifo/icons/user.png`
                                    }
                                    alt=""
                                  />
                                  <div className="message">
                                    <div className="message-author">
                                      {reply.sentUser.firstName +
                                        " " +
                                        reply.sentUser.lastName}
                                    </div>
                                    <span className="message-date">
                                      {formatDate(reply.CreatedAt)}
                                    </span>
                                    <span className="message-content">
                                      {parse(reply.body)}
                                    </span>
                                  </div>
                                </div>
                              ))}
                              <div className="chat-message left">
                                <img
                                  className="message-avatar"
                                  src={
                                    process.env.PUBLIC_URL +
                                    `/invifo/icons/user.png`
                                  }
                                  alt=""
                                />
                                <div className="message">
                                  <div className="message-author"></div>
                                  <span className="message-date">
                                    {formatDate(ticket.emailInquiry.CreatedAt)}
                                  </span>
                                  <span className="message-content">
                                    <root.div>
                                      {parse(ticket.emailInquiry.body)}
                                    </root.div>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </PerfectScrollbar>
                        </div>
                      </div>
                    </React.Fragment>
                  ) : null}
                </TabPanel>
                <TabPanel header="Internal Message" rightIcon="fas fa-envelope">
                  <div className="row">
                    <div className="col-sm-12 col-md-4 col-lg-4">
                      <MessageForm
                        onReloadMessages={() => {
                          getTicketMessagesData(ticket.ID);
                        }}
                        ticketID={ticket.ID}
                      />
                    </div>
                    <div className="col-sm-12 col-md-8 col-lg-8">
                      <MaterialTable
                        columns={[
                          {
                            title: "Posted By",
                            render: (rowData) => (
                              <React.Fragment>
                                <p>
                                  {rowData.fromUser.firstName +
                                    " " +
                                    rowData.fromUser.lastName}
                                </p>
                                <p>{formatDate(rowData.CreatedAt)}</p>
                              </React.Fragment>
                            ),
                          },
                          {
                            title: "Message",
                            field: "message",
                            render: (rowData) => (
                              <p>{parse(rowData.message)}</p>
                            ),
                          },
                        ]}
                        data={messages}
                        options={{
                          toolbar: false,
                          showTitle: false,
                          actionsColumnIndex: -1,
                          pageSize: 10,
                          filtering: true,
                        }}
                        components={{
                          Container: (props) => (
                            <Paper {...props} elevation={0} />
                          ),
                        }}
                      />
                    </div>
                  </div>
                </TabPanel>
              </TabView>
            </div>
          </div>
        </div>
      </div>
      <DialogLayout
        open={openChangeService}
        title="Change Service"
        onCloseDialog={handleCloseChangeService}
      >
        {ticket.ID > 0 ? (
          <ChangeService
            ticketID={ticket.ID}
            groupID={ticket.groupID}
            groupName={ticket.userGroup.groupName}
            onReloadTicket={async (ticketID, groupID) => {
              if (ticket.groupID !== groupID) {
                handleCloseChangeService();
                onReloadTickets();
              }
            }}
            onCloseDialog={handleCloseChangeService}
          />
        ) : null}
      </DialogLayout>
      <DialogLayout
        open={openAssignItem}
        title="Assign Item"
        onCloseDialog={handleCloseAssignItem}
      >
        <AssignItem
          ticketID={ticket.ID}
          onReloadTicket={() => {
            getTicketDetailData(ticket.ID);
          }}
          onCloseDialog={handleCloseAssignItem}
        />
      </DialogLayout>
      <DialogLayout
        open={openQuotationForm}
        title=""
        //color="#f2f3f8"
        maxWIdth="xl"
        onCloseDialog={handleCloseQuotationForm}
      >
        <QuotationForm
          lead={ticket.lead}
          customer={ticket.customer}
          ticketID={ticket.ID}
          user={ticket.user}
          onCloseDialog={handleCloseQuotationForm}
          onConfirmSave={async () => {
            await getTicketDetailData(ticket.ID);
          }}
        />
      </DialogLayout>
    </React.Fragment>
  );

  async function getTicketMessagesData(ticketID) {
    const response = await getTicketMessages(ticketID);
    setMessages(response.data);
  }

  function claimTicketConfirmation() {
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
      },
      buttonsStyling: false,
    })
      .fire({
        title: "Are you sure want to claim this Ticket ?",
        text: "Once claimed, you are responsible to manage this ticket",
        icon: "question",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, claim it`,
        cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          claimTicket(ticket.ID).then((response) => {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Claimed",
              html: response.data.message,
              icon: "success",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
            getTicketDetailData(ticket.ID);
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Cancelled",
            text: "No change has been made",
            icon: "info",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        }
      });
  }

  function handleReplyTicketEmail() {
    if (replyMessage !== "") {
      Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success btn-md btn-pill btn-bold",
          cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
        },
        buttonsStyling: false,
      })
        .fire({
          title: "Are you sure want to send Email Reply ?",
          text: "Please note that you are responsible for this action",
          icon: "question",
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, send it`,
          cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            replyTicketEmail(
              ticket.ID,
              ticket.emailInquiry.emailFrom,
              replyMessage
            ).then((response) => {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Sent",
                html: response.data.message,
                icon: "success",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
              setReplyMessage("");
            });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Cancelled",
              text: "No change has been made",
              icon: "info",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
          }
        });
    } else {
      Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        },
        buttonsStyling: false,
      }).fire({
        title: "Failed",
        text: "Cannot reply empty message",
        icon: "error",
        showCloseButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
      });
    }
  }

  function handleCloseQuotationForm() {
    setOpenQuotationForm(false);
  }

  function handleCloseChangeService() {
    setOpenChangeService(false);
  }

  function handleCloseAssignItem() {
    setOpenAssignItem(false);
  }

  async function getTicketDetailData(ticketID) {
    const response = await getTicketDetail(ticketID);
    setTicket(response.data);
    getTicketMessagesData(ticketID);
    setOpenChangeService(false);
    setOpenAssignItem(false);
    setOpenQuotationForm(false);
  }
}

export default TicketDetail;
